export default __webpack_public_path__ + "static/media/gallery-3.c7ffd3ba.jpg";